import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import { openModal, closeModal } from './components/modal'
import { useFaqAccordion } from './components/accordion'

gsap.registerPlugin(ScrollTrigger)


// 左邊 menu 開關控制
const useFaqController = () => {
  const headerHeight = Number(getComputedStyle(document.documentElement).getPropertyValue('--header-height').split('rem')[0]) * 16
  const controller = $('.faq-menu_controller')
  
  gsap.timeline({
    scrollTrigger: {
      trigger: controller[0],
      start: `top-=${headerHeight + 10} top`,
      end: 'max',
      pin: true,
      pinSpacing: true,
      // markers: true
    }
  })

  controller.on('click', () => {
    openModal('#faq-menu', () => controller.addClass('hidden'))
  })
  $('#faq-menu .faq-menu_bg').on('click', () => {
    closeModal('#faq-menu', () => controller.removeClass('hidden'))
  })
}

// 左邊 menu 項目控制
const useFaqMenu = () => {
  const faqMenu = $('#faq-menu')
  const faqMenuItems = faqMenu.find('.faq-menu_item')
  const slideSpeed = 200

  faqMenuItems.each((i, el) => {
    const self = $(el)
    const head = self.find('.faq-menu_item_head')
    const body = self.find('.faq-menu_item_body')
    head.on('click', () => {
      const isActive = self.hasClass('is-active')
      if (isActive) {
        self.removeClass('is-active')
        body.slideUp(slideSpeed)
      }
      if (!isActive) {
        self.addClass('is-active')
        body.slideDown(slideSpeed)
      }
    })
  })
}


$(() => {
  useFaqController()
  useFaqMenu()
  useFaqAccordion()
})